import React from 'react';
import { Download, FileText } from 'lucide-react';
import { adminProducts, adminCustomers, adminOrders, monthlySales } from '../adminData';

function AdminReports() {
  const totalRevenue = adminOrders.reduce((sum, o) => sum + o.total, 0);
  const maxSales = Math.max(...monthlySales.map(m => m.value));

  const reports = [
    { name: 'Monthly Sales Report', desc: 'Complete breakdown of sales for August 2026', date: '2026-08-04' },
    { name: 'Customer Analytics Report', desc: 'Customer behavior and retention analysis', date: '2026-08-01' },
    { name: 'Inventory Status Report', desc: 'Full stock level and reorder recommendations', date: '2026-07-28' },
    { name: 'Product Performance Report', desc: 'Best and worst performing products', date: '2026-07-25' },
  ];

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Reports</h1>
          <p>Generate and download detailed business reports.</p>
        </div>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <h3>{totalRevenue.toLocaleString()} SAR</h3>
          <p>Revenue This Period</p>
        </div>
        <div className="admin-stat-card">
          <h3>{adminProducts.length}</h3>
          <p>Products Tracked</p>
        </div>
        <div className="admin-stat-card">
          <h3>{adminCustomers.length}</h3>
          <p>Customers Tracked</p>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <h3>Revenue Growth</h3>
        </div>
        <div className="admin-bar-chart">
          {monthlySales.map((m, i) => (
            <div key={i} className="admin-bar-col">
              <div className="admin-bar-value">{(m.value / 1000).toFixed(1)}k</div>
              <div className="admin-bar-track">
                <div className="admin-bar-fill" style={{ height: `${(m.value / maxSales) * 100}%` }}></div>
              </div>
              <div className="admin-bar-label">{m.month}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <h3>Available Reports</h3>
        </div>
        <div className="admin-reports-list">
          {reports.map((r, i) => (
            <div key={i} className="admin-report-row">
              <div className="admin-report-icon"><FileText size={20} /></div>
              <div className="admin-report-info">
                <strong>{r.name}</strong>
                <span>{r.desc}</span>
                <small>{r.date}</small>
              </div>
              <button className="admin-btn-secondary">
                <Download size={14} /> Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminReports;
